import { Trash2, X, CheckSquare } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { cn } from '@/lib/utils';

interface FloatingBulkActionsProps {
  selectedCount: number;
  onBulkDelete: () => void;
  onClearSelection: () => void;
  isLoading?: boolean;
  className?: string;
}

export function FloatingBulkActions({
  selectedCount,
  onBulkDelete,
  onClearSelection,
  isLoading = false,
  className,
}: FloatingBulkActionsProps) {
  if (selectedCount === 0) return null;

  return (
    <div
      className={cn(
        "fixed bottom-6 left-1/2 z-50 transform -translate-x-1/2",
        "animate-in slide-in-from-bottom-4 fade-in-0 duration-300",
        className
      )}
    >
      <div className="flex items-center gap-3 rounded-full border bg-background/95 backdrop-blur-sm px-6 py-3 shadow-lg ring-1 ring-border/50">
        {/* Selection Info */}
        <div className="flex items-center gap-2 text-sm font-medium">
          <CheckSquare className="h-4 w-4 text-primary" />
          <span className="text-foreground">
            {selectedCount} transação{selectedCount > 1 ? 'ões' : ''} selecionada{selectedCount > 1 ? 's' : ''}
          </span>
        </div>

        {/* Divider */}
        <div className="h-4 w-px bg-border" />

        {/* Actions */}
        <div className="flex items-center gap-2">
          <Button
            onClick={onBulkDelete}
            size="sm"
            variant="destructive"
            disabled={isLoading}
            className="rounded-full h-8 px-4 gap-2 text-xs font-medium"
          >
            <Trash2 className="h-3 w-3" />
            Deletar
          </Button>

          <Button
            onClick={onClearSelection}
            size="sm"
            variant="outline"
            disabled={isLoading}
            className="rounded-full h-8 px-4 gap-2 text-xs font-medium"
          >
            <X className="h-3 w-3" />
            Cancelar
          </Button>
        </div>
      </div>
    </div>
  );
}